<template>
  <ConfirmationModal
    :entity="number"
    :title="$t('DELETE_NUMBER_MODAL_TITLE')"
    :cancel-button-text="$t('DELETE_NUMBER_MODAL_CANCEL_ACTION')"
    :confirm-action-text="$t('DELETE_NUMBER_MODAL_CONFIRM_ACTION')"
    :show-confirm-button="!!numberReferences"
    :show-cancel-button="!!numberReferences"
    :on-confirm="onConfirm"
    @confirm="confirmDelete"
    @close="$emit('close')"
  >
    <div v-if="!numberReferences">
      <div>
        <Loader
          v-if="isLoading"
        />
        <span
          v-html="loadingText"
        />
      </div>
    </div>

    <p
      v-if="numberReferences && !numberReferences.hasReferences"
      v-t="'DELETE_NUMBER_MODAL_NUMBER_NONE_ASSOCIATION_TEXT'"
    />

    <div v-if="numberReferences && numberReferences.hasReferences">
      <p
        v-html="$t('DELETE_NUMBER_MODAL_NUMBER_ASSOCIATION_TEXT', { phoneNumber: number.displayNumber })"
      />
      <div class="well well-sm m-t-10 m-b-0">
        <div class="form-horizontal">
          <div
            v-if="numberReferences.campaignId"
            class="row"
          >
            <label class="col-md-3 control-label">
              <strong v-t="'CAMPAIGN'" />
            </label>
            <div class="col-md-8">
              <p class="form-control-static">
                <a
                  v-tooltip.right.hover="$t('VIEW_CAMPAIGN_TEXT')"
                  :href="getHref('dashboard.campaign', { campaignId: numberReferences.campaignId })"
                  target="_blank"
                >
                  {{ numberReferences.campaignName }}
                  <i class="fa fa-external-link m-l-5" />
                </a>
              </p>
            </div>
          </div>
          <div
            v-if="numberReferences.affiliateId"
            class="row"
          >
            <label class="col-md-3 control-label">
              <strong v-t="'PUBLISHER'" />
            </label>
            <div class="col-md-8">
              <p class="form-control-static">
                <a
                  v-tooltip.right.hover="$t('DELETE_NUMBER_MODAL_VIEW_PUBLISHER')"
                  :href="getHref('dashboard.affiliate.edit', { affiliateId: numberReferences.affiliateId })"
                  target="_blank"
                >
                  {{ numberReferences.affiliateName }}
                  <i class="fa fa-external-link m-l-5" />
                </a>
              </p>
            </div>
          </div>
          <div
            v-if="numberReferences.numberpoolId"
            class="row"
          >
            <label class="col-md-3 control-label">
              <strong v-t="'NUMBERS_LINK_POOL'" />
            </label>
            <div class="col-md-8">
              <p class="form-control-static">
                <a
                  v-tooltip.right.hover="$t('DELETE_NUMBER_MODAL_VIEW_PUBLISHER')"
                  :href="getHref('dashboard.numberpool.edit', { numberPoolId: numberReferences.numberpoolId })"
                  target="_blank"
                >
                  {{ numberReferences.numberpoolName }}
                  <i class="fa fa-external-link m-l-5" />
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ConfirmationModal>
</template>


<script>
import { defineComponent } from 'vue';
import Loader from '@/core/components/Loader/index.vue';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal.vue';
import sharedMessages from '@/core/locales';
import messages from '../../locales';
import {
  $ngStateService,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default defineComponent({
  name: 'NumberDeleteModal',
  components: {
    Loader,
    ConfirmationModal,
  },
  props: {
    number: {
      type: Object,
      required: true,
    },
    numberReferences: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    onConfirm: {
      type: Function,
      default: null,
    }
  },
  computed: {
    loadingText() {
      return this.isLoading
        ? this.$t('DELETE_NUMBER_MODAL_NUMBER_CHECK_ASSOCIATION_TEXT')
        : this.$t('DELETE_NUMBER_MODAL_NUMBER_CHECK_ASSOCIATION_ERROR_TEXT');
    },
  },
  methods: {
    confirmDelete(number) {
      this.$emit('confirm', number, false);
    },
    getHref(state, params) {
      return $ngStateService.href(
        state,
        params,
        { absolute: true }
      );
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
});
</script>
